import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Customer } from '../customer-settings.model';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DialogStructureComponent } from '../../../layout/dialog-structure/dialog-structure.component';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';

@Component({
    selector: 'app-customer-settings-dialog',
    templateUrl: './customer-settings-dialog.component.html',
    styleUrls: ['./customer-settings-dialog.component.scss'],
    imports: [DialogStructureComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError]
})
export class CustomerSettingsDialogComponent implements OnInit {
  data: any;

  constructor(
    private dialogRef: MatDialogRef<CustomerSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.data = data;
  }

  customerForm: UntypedFormGroup;
  customer: Customer;

  ngOnInit(): void {
    this.customerForm = new UntypedFormGroup({
      companyName: new UntypedFormControl(null, [Validators.required]),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      firstName: new UntypedFormControl('', [Validators.required]),
      lastName: new UntypedFormControl(null, [Validators.required]),
    });

    if (this.data) {
      this.customer = this.data;
      this.setFormValues(this.data);
    }
  }

  setFormValues(customer: Customer): void {
    this.customerForm.patchValue(customer);
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    // when customer existing -> update
    if (this.customer) {
      this.customer = Object.assign(this.customer, this.customerForm.value);
    } else {
      this.customer = this.customerForm.value;
      // add to table
    }
    this.dialogRef.close(this.customer);
  }
}
